import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useCarLeasingApi } from "../../http/carLeasings/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteCarLeasingDialogProps = {
  carLeasingCarId: string;
  onClose: () => void;
};

const DeleteCarLeasingDialog: FC<DeleteCarLeasingDialogProps> = ({ carLeasingCarId, onClose }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const carLeasingApi = useCarLeasingApi();

  return (
    <ModalDialog
      onClose={onClose}
      isSubmitting={isSubmitting}
      title={i18n.t.carLeasings.delete}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            carLeasingApi
              .deleteAdminCarLeasing(carLeasingCarId)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.carLeasings.questions.delete}
    </ModalDialog>
  );
};

export default DeleteCarLeasingDialog;
